import React from "react";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";

import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

import { IconButton, Typography } from "@material-ui/core";

import SvgI24Menu from "assets/icons/I24Menu";

import TrimmedText from "components/TrimmedText";

import {
  Container,
  ImageContainer,
  DetailsContainer,
  TextContainer,
  TitleWrapper,
  ControlsContainer,
  ControlWrapper,
  MenuControlWrapper,
  Menu,
} from "./styles";

type Props = {
  title: string;
  duration: number;
  image: string;
  details?: any;
  onRemove?: () => void;
  isDragging?: boolean;
  isEditMode?: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  innerRef?: any;
};

class MovementCard extends React.Component<Props> {
  render() {
    const {
      title,
      duration,
      dragHandleProps,
      image,
      isDragging,
      isEditMode,
      innerRef,
      onRemove,
      ...restProps
    } = this.props;

    return (
      <Container
        isEditMode={isEditMode}
        ref={innerRef}
        isDragging={isDragging}
        {...restProps}
      >
        <ImageContainer image={image} />
        <DetailsContainer>
          <TextContainer>
            <TitleWrapper>
              <TrimmedText lines={1} text={title}>
                <Typography variant="h4" color="textPrimary">
                  {title}
                </Typography>
              </TrimmedText>
            </TitleWrapper>
            <Typography variant="subtitle1" color="secondary">
              {duration}
            </Typography>
          </TextContainer>
        </DetailsContainer>
        {isEditMode && (
          <>
            <ControlsContainer>
              <ControlWrapper>
                <IconButton color="secondary" onClick={onRemove}>
                  <DeleteOutlineIcon />
                </IconButton>
              </ControlWrapper>
            </ControlsContainer>

            <MenuControlWrapper>
              <Menu {...dragHandleProps}>
                <SvgI24Menu />
              </Menu>
            </MenuControlWrapper>
          </>
        )}
      </Container>
    );
  }
}

export default MovementCard;
